import { Box, Typography, Button, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { t } from 'i18next';
// import React from "react";

const AdminReview = (props) => {
    const { content, open, closeModal } = props;

    var ChangedFields = !!content?.ChangedFields ? Object.entries(content.ChangedFields) : [];

    return (
        <Dialog
            open={open}
            aria-labelledby="admin-review-modal-title"
            aria-describedby="admin-review-modal-description"
        >
            <DialogTitle>Review parent/guardian and student grade information</DialogTitle>
            <DialogContent>
                <Box>
                    <Typography>
                        The parent/guardian information, the student's grade from last year's application, and the student's private school
                        from this year's application is displayed here for your review.
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-around',
                        }}
                    >
                        <div>
                            <Typography
                                sx={{ borderBottom: '1px solid #979797', fontWeight: 600 }}
                            >{`${content?.PreviousTerm} Application Data`}</Typography>
                            {ChangedFields.map(([key, value]) => {
                                return (
                                    <div key={key}>
                                        <div
                                            style={{
                                                color: '#586874',
                                                fontWeight: 600,
                                                marginTop: '1rem',
                                                marginBottom: '0.25rem',
                                            }}
                                        >
                                            {t(`AppReview.${key}`)}:
                                        </div>
                                        <div
                                            style={{
                                                border: '1px solid #F5F7FF',
                                                backgroundColor: '#F5F7FF',
                                                borderRadius: '4px',
                                                padding: '2px',
                                            }}
                                        >
                                            {value.Previous}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div>
                            <Typography
                                sx={{ borderBottom: '1px solid #979797', fontWeight: 600 }}
                            >{`${content?.CurrentTerm} Application Data`}</Typography>
                            {ChangedFields.map(([key, value]) => {
                                let isChanged = false;
                                if (key !== 'GradeDesc') {
                                    isChanged = value.Previous !== value.Current;
                                } else {
                                    isChanged = value.Previous === value.Current;
                                }

                                return (
                                    <div key={key}>
                                        <div
                                            style={{
                                                color: isChanged ? '#FA6400' : '#586874',
                                                fontWeight: 600,
                                                marginTop: '1rem',
                                                marginBottom: '0.25rem',
                                            }}
                                        >
                                            {t(`AppReview.${key}`)}:
                                        </div>
                                        <div
                                            style={{
                                                border: '1px solid #F5F7FF',
                                                backgroundColor: '#F5F7FF',
                                                borderRadius: '4px',
                                                padding: '2px',
                                            }}
                                        >
                                            {value.Current}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </Box>
                </Box>
                <Box>
                    <Button
                        onClick={() => closeModal()}
                        variant="contained"
                    >
                        Close
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default AdminReview;
